import { THIS_YEAR } from "./consts";
import { isValidField, isZero } from './tool';

const removePercent = (str) => {
  if (!str) return;
  return Number(str.replace("%", ""));
};

const setIcon = (text) => {
  let reg = /\%$/;
  // 负值
  if (removePercent(text) < 0) {
    return `<span class='usdtClass percentageIcon upIcon fw-700'><span class='hiddenHtml'>${reg.test(text) ? text : text + "%"
      }</span></span>`;
  } else {
    return `<span class='usdtClass percentageIcon upIcon fw-700'><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 8.83333L10 3L16 8.83333H12.4V17H7.6V8.83333H4Z" fill="#17E5A1"/>
        </svg><span class='hiddenHtml'>${reg.test(text) ? text : text + "%"
      }</span>
    </span>`;
  }
};

// 50%>X ≥0 新手 
// 80%>X≥50% 菁英
// 100%>X≥80%：大師（包含80%）
const getClassPositionIndex = (percentString = '57%') => {
  const percent = removePercent(percentString);
  if (0 <= percent && percent < 50) {
    return 0;
  } else if (50 <= percent && percent < 80) {
    return 1;
  } else if (80 <= percent && percent <= 100) {
    return 2;
  }
}

const setHiddenHtmlAndFW700 = (text) =>
  `<span class='hiddenHtml fw-700'>${text}</span>`;

const setFW700 = (text) => `<span class='fw-700'>${text}</span>`;

const setTime = ({ year, month, day = "" }) => {
  if (!day) return `<span>${year}-${month}</span>`;

  return `<span>${year}-${month}-${day}</span>`;
};

// 处理区块title，一般是区块有使用过，才会有不同情况的 title
const handleBlockTitle = ({
  firstLevel = 50,
  secondLevel = 80,
  titleArr = [],
  exceeded_users,
}) => {
  if (titleArr.length < 3) return;

  const exceededNum = removePercent(String(exceeded_users));
  const t = window.t;

  if (0 <= exceededNum && exceededNum < firstLevel) {
    return t(titleArr[0]);
  } else if (firstLevel <= exceededNum && exceededNum < secondLevel) {
    return t(titleArr[1]);
  } else {
    return t(titleArr[2]);
  }
};

// 判断空对象
// const checkObjEmpty = (obj = {}) => Object.keys(obj).length === 0;

/**
 * @description: 处理理财宝文案
 * @return {*} {greatHallofEarnTitle, greatHallofEarnText}
 */
function handleFinancialData(props) {
  const t = window.t;

  // 理财宝标题
  const {
    financial_number, //交易次数
    financial_transaction, //交易金额
    financial_transaction_percentage, //同比增长
    financial_transaction_profit, //累计收益，
    financial_transaction_yield, // 累计收益率
    exceeded_users, //超出用户百分比
  } = props;

  // 是否使用过理财宝
  const usedGreatHallofEarn = isValidField(financial_number);

  let greatHallofEarnTitle = t("new.earner");
  let greatHallofEarnText = t("hall_of_earn_text_unused_new");

  if (usedGreatHallofEarn) {
    // 理财宝文案
    // TODO：等UI稿终稿后需要补齐同比增长的icon。
    if (isZero(removePercent(financial_transaction_yield))) {
      greatHallofEarnText = t("hall_of_earn_text_used_nonpercent", {
        financial_number,
        financial_transaction,
        financial_transaction_profit,
        percentageIcon1: setIcon(financial_transaction_percentage),
        exceeded_users,
      });
    } else {
      greatHallofEarnText = t("hall_of_earn_text_used", {
        financial_number,
        financial_transaction,
        financial_transaction_profit,
        percentageIcon1: setIcon(financial_transaction_percentage),
        percentageIcon2: setIcon(financial_transaction_yield),
        exceeded_users,
      });
    }

    // 按照超越用户百分比
    //       50%>X ≥0          Good Earner
    //       80%>X≥50%     Excellent Earner
    //       100%>X≥80%    Outstanding Earner
    const titleArr = ["Good Earner", "Excellent Earner", "Outstanding Earner"];
    greatHallofEarnTitle = handleBlockTitle({ titleArr, exceeded_users });
  }

  return { greatHallofEarnTitle, greatHallofEarnText };
}

// 余币宝
function handleLoanData(props) {
  const t = window.t;
  const {
    // 理财次数
    uniloan_number,
    // 今年理财额
    uniloan_transaction,
    // 理财额同比增长
    uniloan_transaction_percentage,
    // 今年收益额
    uniloan_profit,
    // 收益额同比增长
    uniloan_profit_percentage,
    // 超越用户百分比
    exceeded_users,
  } = props;
  const classTitleIndex = getClassPositionIndex(exceeded_users);
  const classTitleArr = [
    "stable.return.expert",
    "stable.return.elite",
    "stable.return.master",
  ];
  const currentLendClassTitle = t(classTitleArr[classTitleIndex]);
  // 是否使用过余币宝
  const usedThisProduct = isValidField(uniloan_transaction);

  const lendEarnTitle = usedThisProduct ? currentLendClassTitle : t("stable.return.explorer");
  const lendEarnContent = usedThisProduct ? t('landlearn.use.content', {
    uniloan_number,
    uniloan_transaction,
    uniloan_transaction_percentage: setIcon(uniloan_transaction_percentage),
    uniloan_profit,
    exceeded_users,
  }) : t("landlearn.nouse.content");

  return {
    // 当前等级
    lendEarnTitle,
    lendEarnContent,
  }
}

// 财富管理
function handleWealthManagement(props) {
  const t = window.t;
  const {
    // 今年理财额
    wealth_transaction,
    // 理财额同比增长
    wealth_transaction_percentage,
    // 理财总天数
    wealth_day,
    // 今年收益额
    wealth_profit,
    // 收益额同比增长 
    wealth_profit_percentage,
    // 超越用户百分比
    exceeded_users,
    // 理财次数
    wealth_number,
    // 待添加字段
    top_gain_product,
    // 待添加字段
    top_gain_ratio,
  } = props;
  const classTitleIndex = getClassPositionIndex(exceeded_users);
  const classTitleArr = [
    "wealth.management.expert",
    "wealth.management.master",
    "wealth.management.grandmaster",
  ];
  const currentWealthClassTitle = t(classTitleArr[classTitleIndex]);
  // 是否使用过财富管理
  const usedThisProduct = isValidField(wealth_transaction);
  const healthWealthTitle = usedThisProduct ? currentWealthClassTitle : t("wealth.management.explorer");
  const healthWealthContent = usedThisProduct ? t('gateway.use.wealth.content', {
    wealth_transaction,
    wealth_transaction_percentage: setIcon(wealth_transaction_percentage),
    wealth_day,
    wealth_profit,
    exceeded_users,
    wealth_product: top_gain_product,
    wealth_product_profit_percentage: setIcon(top_gain_ratio),
  }) : t("gateway.nouse.wealth.content");

  return {
    // 当前财富等级
    healthWealthTitle,
    healthWealthContent,
  }
}

// ETF 杠杆
function handleETFTransaction(props) {
  const t = window.t;
  const {
    etf_number, //交易次数
    etf_transaction, //交易金额
    etf_transaction_percentage, //同比增长
    exceeded_users, //超出用户百分比
  } = props;

  const usedETF = isValidField(etf_number);

  let etfText = t("etf_text_unused");
  let etfTitle = t("People Who Seek Stable Return");

  if (usedETF) {
    etfText = t("etf_text_used", {
      etf_number: setHiddenHtmlAndFW700(etf_number),
      etf_transaction,
      exceeded_users: setHiddenHtmlAndFW700(exceeded_users),
      percentageIcon: `${setIcon(etf_transaction_percentage)} <br/ >`,
    });

    const titleArr = [
      "People Who Seek Stable Return",
      "People Who Lever Wealth",
      "People Who Roll Wealth Snowballs",
    ];

    // 按照超越用户百分比
    // 50%>X ≥0      稳中求胜的人
    // 80%>X≥50%     撬动财富的人
    // 100%>X≥80%    滚雪球的人
    etfTitle = handleBlockTitle({ titleArr, exceeded_users });
  }

  return { etfTitle, etfText };
}

// NFT
function handleNFT(props) {
  const t = window.t;
  const {
    // "year": "2022",
    // nft_time, // "2022-11-17",//第一次铸造NFT的时间
    nft_count = 0, //铸造的作品
    nft_number = 0, //交易的作品
    // nft_transaction, // 80,//交易的金额
    // nft_transaction_percentage, // "10%",//同比增长
    max_nft_transaction, // 90,//最佳作品金额
    // max_nft_transaction_percentage, // "15%",//最佳作品的同比增长
    // exceeded_users, //"50%",//超出用户百分比
    // nft_url = [], //NFT展示
    max_nft_name: best_nft_name = "",
  } = props;

  // const best_nft_url = nft_url[0];

  const usedNFT = Number(nft_count + nft_number) > 0;
  // const usedNFT = false

  let nftTitle = t("NFT Magical World");
  // 副标题，未使用过NFT 时使用
  const subhead = t("Connect You to the New World");
  let nftText = `<span class='nft-subhead'>${subhead}</span><br />${t(
    "nft_text_unused",
  )}`;

  if (usedNFT) {
    // 铸造的 nft 作品数量
    let nftProductText = "";
    if (Number(nft_count) >= 0) {
      nftProductText = t("minted_NFT_items_fixed", {
        nft_count: setHiddenHtmlAndFW700(nft_count),
      });
    }
    // 最佳交易
    let traded_NFT_items = "";
    let best_NFT_name = "";
    if (Number(nft_number) > 0) {
      traded_NFT_items = t("traded_NFT_items", {
        nft_number: setHiddenHtmlAndFW700(nft_number),
      });
      best_NFT_name = t("best_NFT_name_fixed", {
        best_nft_name: setHiddenHtmlAndFW700(best_nft_name),
        max_nft_transaction,
      });
    } else if (Number(nft_number) === 0) {
      traded_NFT_items = t("traded_NFT_items", {
        nft_number: setHiddenHtmlAndFW700(nft_number),
      });
    }

    nftText = `<p>${t("nft_text_used_first_line_fixed", {
      thisYear: THIS_YEAR,
    }).replace(
      "fw-700",
      "",
    )} <br /> ${nftProductText} <br /> ${traded_NFT_items} </p> <p>${best_NFT_name}</p>`;

    //     年度关键词方案
    // 按照2022年交易+铸造个数
    //                     0    不展示
    //     （50＞个数≥1)    NFT High-flyer
    //     （100＞个数≥50)   NFT Pioneer
    //     （300＞个数≥100)  NFT Artist
    //     （1000>个数≥300)   NFT Adventurer
    //      （个数≥1000)           NFT Tastemaker
    const allNftCount = Number(nft_count) + Number(nft_number);
    if (allNftCount >= 1 && allNftCount < 50) {
      nftTitle = t("NFT High-flyer");
    } else if (allNftCount >= 50 && allNftCount < 100) {
      nftTitle = t("NFT Pioneer");
    } else if (allNftCount >= 100 && allNftCount < 300) {
      nftTitle = t("NFT Artist");
    } else if (allNftCount >= 300 && allNftCount < 1000) {
      nftTitle = t("NFT Adventurer");
    } else if (allNftCount >= 1000) {
      nftTitle = t("NFT Tastemaker");
    }
  }

  return { nftTitle, nftText };
}

// 量化跟单
const handleStrategyBot = (props) => {
  const t = window.t;
  const {
    user_type, // 1：跟单员，2：未使用过
    original_policy_number, // 8,//量化策略原创次数
    original_policy_copy_number, // 10000,//策略被复制次数
    total_copy_order_trade = {},
    prominent, // 50,//超过用户百分比
  } = props;

  // const user_type = 2;

  let strategyBotTitle = t("quant.apprentice"),
    strategyBotText = t("strategy_bot_text_unused");

  if (user_type == 1) {
    // 按照超越的用戶百分比
    // 50%>X ≥0     Quant Warrior 量化少侠
    // 75%>X≥50%   Quant Hero 量化大侠
    // 100%>X≥75%  Quant Master 量化宗师
    const titleArr = ["Quant Warrior", "Quant Hero", "Quant Master"];

    strategyBotTitle = handleBlockTitle({
      titleArr,
      secondLevel: 75,
      exceeded_users: prominent,
    });
    strategyBotText = t("quant_bot_text_used", {
      original_policy_number: setHiddenHtmlAndFW700(original_policy_number),
      original_policy_copy_number: setHiddenHtmlAndFW700(
        original_policy_copy_number,
      ),
      total_copy_order_trade,
      prominent: setHiddenHtmlAndFW700(prominent),
    });
  }

  return { strategyBotTitle, strategyBotText };
};

// 实盘跟单
const handleCopyTrader = (props) => {
  var t = window.t;
  const {
    user_type, // 1：带单员 merchandiser；2：跟单员 Discerning Trader；3：未使用过，则没有以下任何数据；
    // 带单员数据
    apply_time = {},
    copy_order_number, // 8,//年度带单人数 || 实盘跟单次数
    copy_order_earn, // 10000,//用户跟单赚钱的总金额
    copy_order_brokerage, // 1000,//交易员抽取的佣金
    prominent, // 55,//超过用户百分比

    // 跟单员数据
    biggest_earn, // 100,//收益最高的一次金额
    biggest_yield, // 10,//收益最高的一次百分比
  } = props;

  const { year, month, day } = apply_time;

  // const user_type = 3;
  // const user_type = 2;

  let copyTraderTitle = t("Insightful Trader"),
    copyTraderText = t("copy_Trader_text_unused");

  if (user_type == 1) {
    // 带单员
    copyTraderText = t("Trader_1_text", {
      time: setTime({ year, month, day }),
      copy_order_number: setHiddenHtmlAndFW700(copy_order_number),
      copy_order_earn,
      copy_order_brokerage,
      prominent: setHiddenHtmlAndFW700(prominent),
    });

    // 按照超越的用戶百分比
    // 50%>X ≥0   高级交易员 Advanced Trader
    // 75%>X≥50%  优质交易员 Premium Trader
    // 100%>X≥75%  最优交易员 Best Trader
    const titleArr = ["Advanced Trader", "Premium Trader", "Best Trader"];
    copyTraderTitle = handleBlockTitle({
      secondLevel: 75,
      titleArr,
      exceeded_users: prominent,
    });
  } else if (user_type == 2) {
    // 跟单员
    copyTraderText = t("Trader_2_text", {
      // time: setTime({year, month, day}),
      copy_order_number: setHiddenHtmlAndFW700(copy_order_number),
      biggest_earn,
      biggest_yield: setHiddenHtmlAndFW700(biggest_yield),
      prominent: setHiddenHtmlAndFW700(prominent),
    });

    // 按照超越的用戶百分比
    //   50%>X ≥0      Insightful
    //   75%>X≥50%  Sharp-sighted
    // 100%>X≥75%  Discerning
    const titleArr = [
      "Insightful Trader",
      "Sharp-sighted Trader",
      "Discerning Trader",
    ];

    copyTraderTitle = handleBlockTitle({
      secondLevel: 75,
      titleArr,
      exceeded_users: prominent,
    });
  }

  return { copyTraderTitle, copyTraderText };
};

// Learn
const handleLearn = (props) => {
  const t = window.t;

  const {
    collect_number = 0, // 31,//收藏篇数
    prominent: exceeded_users, // 30//超越用户百分比
  } = props;

  let learnTitle = t("Gate Learn Avenue"),
    learnText = t("learn_text_unused");

  //   用戶類型分類判斷
  // 使用過（完成閱讀至少一篇Gate學院文章）
  // 未使用（未完成閱讀過Gate學院文章）
  const learnUsed = isValidField(collect_number);
  // const learnUsed = false;

  if (learnUsed) {
    learnText = t("learn_text_used", {
      time: setTime({ year: THIS_YEAR, month: 7 }),
      collect_number: setHiddenHtmlAndFW700(collect_number),
      exceeded_users: setHiddenHtmlAndFW700(exceeded_users),
    });
    // 按照超越的用戶百分比
    // 50%>X≥0%     Informed
    // 80%>X≥50%   Learned
    // 100%>X≥80%  Erudite
    const titleArr = ["Informed", "Learned", "Erudite"];
    learnTitle = handleBlockTitle({ titleArr, exceeded_users });
  }

  return { learnText, learnTitle };
};

// 动态
const handleGateCommunity = (props) => {
  const t = window.t;
  const {
    release_time = {}, //第一次发布时间
    interact_number, // 30,//互动次数
    prominent: exceeded_users, // 70//超越用户百分比
  } = props;

  const {
    year, // "2022",
    month, //"11",
    day, //"15"
  } = release_time;

  //   用戶類型分類判斷
  // 使用過（進行過動態發布）
  // 未使用（未進行過動態發布）

  const gateCommunityUsed = release_time.year || false;
  // const gateCommunityUsed = false;

  let gateCommunityTitle = `<div class=''>${t(
    "Find Crypto Friends Share Your Insights",
  ).replace("<br/>", " ")}<div>`,
    gateCommunityText = t("gat_community_text_unused");

  if (gateCommunityUsed) {
    // 没有发表过动态，但是有过互动 则前三行不显示。

    gateCommunityText = t("gat_community_text_used_2", {
      interact_number: setHiddenHtmlAndFW700(interact_number),
      exceeded_users: setHiddenHtmlAndFW700(exceeded_users),
    });
    if (year && day && month) {
      const gateCommunityText1 = t("gat_community_text_used_1", {
        time: setTime({ month, day, year }),
      });
      gateCommunityText = `<p>${gateCommunityText1}</p>${gateCommunityText}`;
    }
    //     年度关键词方案
    // 按照超越的用戶百分比
    //       50%>X ≥0      Community Rookie
    //       75%>X≥50%  Community Influencer
    //      100%>X≥75%  Opinion Leader
    const titleArr = [
      "Community Rookie",
      "Community Influencer",
      "Opinion Leader",
    ];

    gateCommunityTitle = handleBlockTitle({
      titleArr,
      secondLevel: 75,
      exceeded_users,
    });
  }

  return { gateCommunityText, gateCommunityTitle };
};

// live 直播
const handleLive = (props) => {
  const t = window.t;
  //   用戶類型分類判斷
  // 直播主（進行過直播）
  // 未使用（未進行過直播）

  const {
    established, // 2 ,//成立年份 2年
    live_number, // 30,//直播次数
    every_day, // 50//平均每天直播次数
  } = props;

  // const usedLive = !checkObjEmpty(props) || false;
  // const usedLive = false;

  let liveText = t("live_text_unused", {
    established: setFW700(established),
    live_number: setFW700(live_number),
    every_day: setFW700(every_day),
  }),
    liveTitle = t("Explore Gate Live");

  // if(usedLive) {
  //   liveText = t('live_text_used', {
  //     established: setFW700(established),
  //     live_number: setFW700(live_number),
  //     every_day: setFW700(every_day)
  //   })
  // }

  return { liveText, liveTitle };
};

export {
  setFW700,
  setIcon,
  handleBlockTitle,
  handleFinancialData,
  handleETFTransaction,
  handleNFT,
  handleCopyTrader,
  handleStrategyBot,
  handleLearn,
  handleGateCommunity,
  handleLive,
  handleLoanData,
  handleWealthManagement,
  removePercent
};
